import ArchivedBody from "./BodyText/ArchivedBodyText";
import CertifiedBody from "./BodyText/CertifiedBodyText";
import InProgressBody from "./BodyText/InProgressBodyText";

interface PclHeaderTextProps {
  status: string;
}

const PclHeaderText = ({ status }: PclHeaderTextProps) => {
  if (status === "Certified") return <CertifiedBody />;
  if (status === "In Progress") return <InProgressBody />;

  return <ArchivedBody />;
};
export default PclHeaderText;
